/* eslint-disable */
import _ from "lodash/fp";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import advertisementDetailsLabel from "../../application_management/labels/advertisement_details_en.json";
import ModuleHide from "../../common/components/ModuleHide";
import {
  addressValidation,
  onlyCharacters,
  pincode,
} from "../../common/constants/regex";
import commonENLabels from "../../common/labels/common_en.json";
import commonHILabels from "../../common/labels/common_hi.json";
import "../../styles/advertisementTable.css";
import "../../styles/profile.css";
import {
  addressAction,
  getAddressInformation,
  getAllStatesList,
  getFormattedLastUpdatedDate,
  setDistrictDropdown,
  setDistrictDropdownCorrespondenceAddress,
  setTalukaDropdown,
  setTalukaDropdownCorrespondenceAddress,
  setVillageDropdown,
  setVillageDropdownCorrespondenceAddress,
} from "../actions/profileAction";
import profileadressinformation from "../labels/adress_information_en.json";
import profile from "../labels/personal_information_en.json";
import numberformat from "../labels/serial_nos_en.json";
import { disableAllSaveAfterSubmit} from "../actions/profileAction";

function AddressInformation(props) {
  const { register, errors, handleSubmit, setValue, clearErrors } = useForm({
    mode: "onChange",
  });

  // module-enable-disable
  const { moduleList } = useSelector(
    (state) => state.loginReducer,
    shallowEqual
  );
  const [arraymModule, setarraymModule] = useState({});

  useEffect(() => {
    setarraymModule(
      moduleList &&
      moduleList.filter((ele) => ele.moduleName === "ADDRESS_INFO")[0]
    );
  }, [moduleList]);

  const [permenantAddressState, setPermenantAddressState] = useState({
    permenantHouseNo: "",
    permenantBuildingName: "",
    permenantRoadOrPo: "",
    permenantArea: "",
    permenantLandmark: "",
    permenantState: "",
    permenantDistrict: "",
    permenantTaluka: "",
    permenantVillageCity: "",
    permenantDistrict1: "",
    permenantTaluka1: "",
    permenantVillageCity1: "",
    permenantPin: "",
  });

  const [correspondenceAddressState, setCorrespondenceAddressState] = useState({
    correspondenceHouseNo: "",
    correspondenceBuildingName: "",
    correspondenceRoadOrPo: "",
    correspondenceArea: "",
    correspondenceLandmark: "",
    correspondenceState: "",
    correspondenceDistrict: "",
    correspondenceTaluka: "",
    correspondenceVillageCity: "",
    correspondenceDistrict1: "",
    correspondenceTaluka1: "",
    correspondenceVillageCity1: "",
    correspondencePin: "",
  });




  useEffect(() => {
    dispatch(getAllStatesList());
  }, []);
  const handlePermenantAddressChange = (evt) => {
    const value = evt.target.value;
    if (evt.target.type === "select-one") {
      if (evt.target.name === "permenantState") {
        dispatch(setDistrictDropdown(value));
      } else if (evt.target.name === "permenantDistrict") {
        dispatch(setTalukaDropdown(value));
      } else if (evt.target.name === "permenantTaluka") {
        dispatch(setVillageDropdown(value));
      }
    }
    if (isSameAsAbove) {
      // switch (evt.target.name) {
      //   case "permenantState":
      //     dispatch(setDistrictDropdownCorrespondenceAddress(value));
      //   case "permenantDistrict":
      //     dispatch(setTalukaDropdownCorrespondenceAddress(value));
      //   case "permenantTaluka":
      //     dispatch(setVillageDropdownCorrespondenceAddress(value));
      // }
      if (evt.target.name === "permenantState") {
        dispatch(setDistrictDropdownCorrespondenceAddress(value));
      } else if (evt.target.name === "permenantDistrict") {
        dispatch(setTalukaDropdownCorrespondenceAddress(value));
      } else if (evt.target.name === "permenantTaluka") {
        dispatch(setVillageDropdownCorrespondenceAddress(value));
      }
    }
    if (isSameAsAbove) {
      sameAsAboveChanges(evt.target.name, evt.target.value);
    }
    if (evt.target.name === "permenantState") {
      setPermenantAddressState({
        ...permenantAddressState,
        ["permenantState"]: value,
        ["permenantDistrict"]: "",
        ["permenantTaluka"]: "",
        ["permenantVillageCity"]: "",
        ["permenantDistrict1"]: "",
        ["permenantTaluka1"]: "",
        ["permenantVillageCity1"]: "",
        // ["correspondenceDistrict1"]: "",
        // ["correspondenceTaluka1"]: "",
        // ["correspondenceVillageCity1"]: "",
        // ["correspondenceDistrict"]: "",
        // ["correspondenceTaluka"]: "",
        // ["correspondenceVillageCity"]: "",
      });
      setValue("permenantDistrict", "");
      setValue("permenantTaluka", "");
      setValue("permenantVillageCity", "");
      setValue("permenantDistrict1", "");
      setValue("permenantTaluka1", "");
      setValue("permenantVillageCity1", "");
      // setValue("correspondenceDistrict1", "");
      // setValue("correspondenceTaluka1", "");
      // setValue("correspondenceVillageCity1", "");
      // setValue("correspondenceDistrict", "");
      // setValue("correspondenceTaluka", "");
      // setValue("correspondenceVillageCity", "");
    } else {
      setPermenantAddressState({
        ...permenantAddressState,
        [evt.target.name]: value,
      });
    }
  };

  function sameAsAboveChanges(name, value) {
    if (name === "permenantHouseNo") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        ["correspondenceHouseNo"]: value,
      });
      setValue("correspondenceHouseNo", value);
      if (!errors.permenantHouseNo) {
        clearErrors("correspondenceHouseNo");
      }
    }

    if (name === "permenantBuildingName") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        ["correspondenceBuildingName"]: value,
      });
      setValue("correspondenceBuildingName", value);
      if (!errors.permenantBuildingName) {
        clearErrors("correspondenceBuildingName");
      }
    }

    if (name === "permenantRoadOrPo") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        ["correspondenceRoadOrPo"]: value,
      });
      setValue("correspondenceRoadOrPo", value);
      if (!errors.permenantRoadOrPo) {
        clearErrors("correspondenceRoadOrPo");
      }
    }

    if (name === "permenantLandmark") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        ["correspondenceLandmark"]: value,
      });
      setValue("correspondenceLandmark", value);
      if (!errors.permenantLandmark) {
        clearErrors("correspondenceLandmark");
      }
    }

    if (name === "permenantPin") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        ["correspondencePin"]: value,
      });
      setValue("correspondencePin", value);
      if (!errors.permenantPin) {
        clearErrors("correspondencePin");
      }
    }

    if (name === "permenantState") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        ["correspondenceState"]: value,
      });
      setValue("correspondenceState", value);
      clearErrors("correspondenceState");
    }

    if (name === "permenantDistrict") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        ["correspondenceDistrict"]: value,
      });
      setValue("correspondenceDistrict", value);
      clearErrors("correspondenceDistrict");
    }

    if (name === "permenantTaluka") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        ["correspondenceTaluka"]: value,
      });
      setValue("correspondenceTaluka", value);
      clearErrors("correspondenceTaluka");
    }

    if (name === "permenantVillageCity") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        ["correspondenceVillageCity"]: value,
      });
      setValue("correspondenceVillageCity", value);
      clearErrors("correspondenceVillageCity");
    }

    if (name === "permenantDistrict1") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        ["correspondenceDistrict1"]: value,
      });
      setValue("correspondenceDistrict1", value);
      if (!errors.permenantDistrict1) {
        clearErrors("correspondenceDistrict1");
      }
    }

    if (name === "permenantTaluka1") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        ["correspondenceTaluka1"]: value,
      });
      setValue("correspondenceTaluka1", value);
      if (!errors.permenantTaluka1) {
        clearErrors("correspondenceTaluka1");
      }
    }

    if (name === "permenantVillageCity1") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        ["correspondenceVillageCity1"]: value,
      });
      setValue("correspondenceVillageCity1", value);
      if (!errors.permenantVillageCity1) {
        clearErrors("correspondenceVillageCity1");
      }
    }
  }

  const handleCorrespondenceAddressChange = (evt) => {
    const value = evt.target.value;
    const name = evt.target.name;
    if (evt.target.type === "select-one") {
      if (evt.target.name === "correspondenceState") {
        dispatch(setDistrictDropdownCorrespondenceAddress(value));
      } else if (evt.target.name === "correspondenceDistrict") {
        dispatch(setTalukaDropdownCorrespondenceAddress(value));
      } else if (evt.target.name === "correspondenceTaluka") {
        dispatch(setVillageDropdownCorrespondenceAddress(value));
      }
    }
    if (name === "correspondenceState") {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        [evt.target.name]: value,
        ['correspondenceDistrict1']: '',
        ['correspondenceTaluka1']: '',
        ['correspondenceVillageCity1']: '',
        ['correspondenceDistrict']: '',
        ['correspondenceTaluka']: '',
        ['correspondenceVillageCity']: '',
        ['correspondencePin']: '',
      });
    } else {
      setCorrespondenceAddressState({
        ...correspondenceAddressState,
        [evt.target.name]: value,
      });
    }
  };

  const [isSameAsAbove, setIsSameAsAbove] = useState(false);
  const dispatch = useDispatch();
  const statesList = useSelector((state) => state.profile.statesList);
  const districtList = useSelector((state) => state.profile.districtList);
  const districtCorrespondenceList = useSelector(
    (state) => state.profile.districtCorrespondenceList
  );
  const talukaList = useSelector((state) => state.profile.talukaList);

  const addressInfo = useSelector((state) => state.profile.addressInformationResponse);


  const talukaCorrespondenceList = useSelector(
    (state) => state.profile.talukaCorrespondenceList
  );
  const villageList = useSelector((state) => state.profile.villageList);
  const villageCorrospondenceList = useSelector(
    (state) => state.profile.villageCorrospondenceList
  );
  const isDisableAllTabSave = useSelector(
    (state) => state.profile.isDisableAllTabSave
  );

  function handleClick() {
    var toggleValue = !isSameAsAbove;
    setIsSameAsAbove(toggleValue);
    if (toggleValue) {
      // Correspondance Address would be same as Permenant Address
      dispatch(
        setDistrictDropdownCorrespondenceAddress(
          permenantAddressState.permenantState
        )
      );
      dispatch(
        setTalukaDropdownCorrespondenceAddress(
          permenantAddressState.permenantDistrict
        )
      );
      dispatch(
        setVillageDropdownCorrespondenceAddress(
          permenantAddressState.permenantTaluka
        )
      );
      setCorrespondenceAddressState({
        correspondenceHouseNo: permenantAddressState.permenantHouseNo,
        correspondenceBuildingName: permenantAddressState.permenantBuildingName,
        correspondenceRoadOrPo: permenantAddressState.permenantRoadOrPo,
        correspondenceArea: permenantAddressState.permenantArea,
        correspondenceLandmark: permenantAddressState.permenantLandmark,
        correspondenceState: permenantAddressState.permenantState,
        correspondenceDistrict: permenantAddressState.permenantDistrict,
        correspondenceTaluka: permenantAddressState.permenantTaluka,
        correspondenceVillageCity: permenantAddressState.permenantVillageCity,
        correspondencePin: permenantAddressState.permenantPin,
        correspondenceDistrict1: permenantAddressState.permenantDistrict1,
        correspondenceTaluka1: permenantAddressState.permenantTaluka1,
        correspondenceVillageCity1: permenantAddressState.permenantVillageCity1,
      });
      setValue("correspondenceHouseNo", permenantAddressState.permenantHouseNo);
      clearErrors("correspondenceHouseNo");
      setValue(
        "correspondenceBuildingName",
        permenantAddressState.permenantBuildingName
      );
      clearErrors("correspondenceBuildingName");
      setValue(
        "correspondenceRoadOrPo",
        permenantAddressState.permenantRoadOrPo
      );
      clearErrors("correspondenceRoadOrPo");
      setValue("correspondenceArea", permenantAddressState.permenantArea);
      clearErrors("correspondenceArea");
      setValue(
        "correspondenceLandmark",
        permenantAddressState.permenantLandmark
      );
      clearErrors("correspondenceLandmark");
      setValue("correspondenceState", permenantAddressState.permenantState);
      clearErrors("correspondenceState");
      setValue(
        "correspondenceDistrict",
        permenantAddressState.permenantDistrict
      );
      clearErrors("correspondenceDistrict");
      setValue("correspondenceTaluka", permenantAddressState.permenantTaluka);
      clearErrors("correspondenceTaluka");
      setValue(
        "correspondenceVillageCity",
        permenantAddressState.permenantVillageCity
      );
      clearErrors("correspondenceVillageCity");
      setValue("correspondencePin", permenantAddressState.permenantPin);
      clearErrors("correspondencePin");
      setValue(
        "correspondenceDistrict1",
        permenantAddressState.permenantDistrict1
      );
      clearErrors("correspondenceDistrict1");
      setValue("correspondenceTaluka1", permenantAddressState.permenantTaluka1);
      clearErrors("correspondenceTaluka1");
      setValue(
        "correspondenceVillageCity1",
        permenantAddressState.permenantVillageCity1
      );
      clearErrors("correspondenceVillageCity1");
      setValue("correspondencePin", permenantAddressState.permenantPin);
      clearErrors("correspondencePin");
    }
  }

  let addressInformationResponse = useSelector(
    (state) => state.profile.addressInformationResponse
  );




  const autoPopulateSetDropdowns = () => {
    dispatch(
      setDistrictDropdown(
        addressInformationResponse.permenantAddressState.permenantState
      )
    );
    dispatch(
      setTalukaDropdown(
        addressInformationResponse.permenantAddressState.permenantDistrict
      )
    );
    dispatch(
      setVillageDropdown(
        addressInformationResponse.permenantAddressState.permenantTaluka
      )
    );
    dispatch(
      setDistrictDropdownCorrespondenceAddress(
        addressInformationResponse.correspondenceAddressState
          .correspondenceState
      )
    );
    dispatch(
      setTalukaDropdownCorrespondenceAddress(
        addressInformationResponse.correspondenceAddressState
          .correspondenceDistrict
      )
    );
    dispatch(
      setVillageDropdownCorrespondenceAddress(
        addressInformationResponse.correspondenceAddressState
          .correspondenceTaluka
      )
    );
  };
  const handleAddressInfoSubmit = (data) => {
    let permenantDistrictData = getDropdownOptionName(
      permenantAddressState.permenantDistrict,
      districtList
    );
    let permenantTalukaData = getDropdownOptionName(
      permenantAddressState.permenantTaluka,
      talukaList
    );
    let permenantVillageCityData = getDropdownOptionName(
      permenantAddressState.permenantVillageCity,
      villageList
    );
    let correspondenceDistrictData = getDropdownOptionName(
      correspondenceAddressState.correspondenceDistrict,
      districtList
    );
    let correspondenceTalukaData = getDropdownOptionName(
      correspondenceAddressState.correspondenceTaluka,
      talukaList
    );
    let correspondenceVillageCityData = getDropdownOptionName(
      correspondenceAddressState.correspondenceVillageCity,
      villageList
    );

    const updatedPermenantAddressState = {
      ...permenantAddressState,
      permenantDistrict1: permenantAddressState.permenantDistrict
        ? permenantDistrictData
        : "",
      permenantTaluka1: permenantAddressState.permenantTaluka
        ? permenantTalukaData
        : "",
      permenantVillageCity1: permenantAddressState.permenantVillageCity
        ? permenantVillageCityData
        : "",
    };

    const updatedCorrespondenceAddressState = {
      ...correspondenceAddressState,
      correspondenceDistrict1: correspondenceAddressState.correspondenceDistrict
        ? correspondenceDistrictData
        : correspondenceAddressState.correspondenceDistrict1 ? correspondenceAddressState.correspondenceDistrict1 : '',
      correspondenceTaluka1: correspondenceAddressState.correspondenceTaluka
        ? correspondenceTalukaData
        : correspondenceAddressState.correspondenceTaluka1 ? correspondenceAddressState.correspondenceTaluka1 : '',
      correspondenceVillageCity1:
        correspondenceAddressState.correspondenceVillageCity
          ? correspondenceVillageCityData
          : correspondenceAddressState.correspondenceVillageCity1 ? correspondenceAddressState.correspondenceVillageCity1 : '',
    };
    if (
      parseInt(permenantAddressState.permenantState) ===
      commonENLabels.DATABASE_VALUES.STATE_CODE
    ) {
      let addressInfoReq = {
        ...updatedPermenantAddressState,
        ...updatedCorrespondenceAddressState,
        isSameAsAbove,
      };
      dispatch(addressAction(addressInfoReq));
    } else {
      let addressInfoReq = {
        ...permenantAddressState,
        ...correspondenceAddressState,
        isSameAsAbove,
      };
      dispatch(addressAction(addressInfoReq));
    }
  };

  /** Get and set the Address Information (If already stored) on page load */
  useEffect(() => {
    dispatch(getAddressInformation());
  }, []);

  /** Get and set the latest Address Information on successful Save/Update */
  useEffect(() => {
    setPermenantAddressState({
      ...addressInformationResponse.permenantAddressState,
    });

    setCorrespondenceAddressState({
      ...addressInformationResponse.correspondenceAddressState,
    });
    setIsSameAsAbove(addressInformationResponse.isSameAsAbove);
    autoPopulateSetDropdowns();
  }, [addressInformationResponse]);

  const getDropdownOptionName = (code, myDropdownOptions) => {
    let selectedOption = myDropdownOptions.find((element) => {
      return element.code === code;
    });
    return selectedOption ? selectedOption.name : "";
  };


  
    
    useEffect(() => {
      if (!props.profileStatus) {
        dispatch(disableAllSaveAfterSubmit(false));
      } else if (
        props.enableEditProfileWithLock?.editProfileWithLock == "1"
      ) {
        dispatch(disableAllSaveAfterSubmit(false));
      } else {
        dispatch(disableAllSaveAfterSubmit(true));
      }
    }, [dispatch, props.profileStatus, props.enableEditProfileWithLock?.editProfileWithLock]);
    
  


  const formattedUpdatedDate = new Date(permenantAddressState?.updatedAt)?.toLocaleDateString("en-GB");

  return arraymModule && arraymModule.isEnabled == false ? (
    <ModuleHide details={arraymModule} />
  ) : (
    <form onSubmit={handleSubmit(handleAddressInfoSubmit)}>
      <div className="p-4 f12">
        <div className="p-1 bg-blue date_flex">
          <h5 className="text-white ">
            <img src="/icons/user-detail.png" /> &nbsp;
            {commonENLabels.ADDRESS_INFORMATION.ADDRESS_INFORMATION}{" "}
            {commonHILabels.ADDRESS_INFORMATION.ADDRESS_INFORMATION}
          </h5>
          <h5 className="text-white last_updated_date">
            {commonENLabels.LAST_UPDATED_ON}{" "}
            {getFormattedLastUpdatedDate(formattedUpdatedDate)}
          </h5>
        </div>
        <div>
          <h5 className="m-1 mt-3 bottom-dotted-line">
            2. {profileadressinformation.PERMENANT_ADDRESS} :{" "}
            {commonHILabels.ADDRESS_INFORMATION.PERMANENT_ADDRESS}
          </h5>
        </div>
        <br />
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="LeftText f11 font-weight">
              {numberformat["2.1"]}&nbsp;
              {commonENLabels.ADDRESS_INFORMATION.ADDRESS_LINE_1}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.ADDRESS_INFORMATION.NOTE_2_1}
            </label>
            <span className="errorText">*</span>
            <div className="input-group bg-color">
              <input
                type="text"
                minLength={1}
                maxLength={100}
                className="form-control text-uppercase"
                name="permenantHouseNo"
                defaultValue={permenantAddressState.permenantHouseNo}
                ref={register({ required: true, pattern: addressValidation })}
                onChange={handlePermenantAddressChange}
                autoComplete="off"
              ></input>
            </div>
            {_.get("permenantHouseNo.type", errors) === "pattern" && (
              <p className="errorText">
                {profileadressinformation.ENTER_VALID_ADDRESS}
              </p>
            )}
            {_.get("permenantHouseNo.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
            <span className="float-start ms-1 mt-1 f13">
              {" "}
              {profile["INFO_HELP_ERROR_TEXT "]}
            </span>
          </div>
          <div className="col-md-4 mb-3">
            <label className="LeftText f11 font-weight">
              {numberformat["2.2"]}&nbsp;
              {commonENLabels.ADDRESS_INFORMATION.ADDRESS_LINE_2}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.ADDRESS_INFORMATION.NOTE_2_2}
            </label>
            <div className="input-group bg-color">
              <input
                type="text"
                minLength={1}
                maxLength={100}
                className="form-control text-uppercase"
                name="permenantBuildingName"
                defaultValue={permenantAddressState.permenantBuildingName}
                ref={register({ required: false, pattern: addressValidation })}
                onChange={handlePermenantAddressChange}
                autoComplete="off"
              ></input>
            </div>
            {_.get("permenantBuildingName.type", errors) === "pattern" && (
              <p className="errorText">
                {" "}
                {profileadressinformation.ENTER_VALID_ADDRESS}
              </p>
            )}
          </div>
          <div className="col-md-4 mb-3">
            <label className="LeftText f11 font-weight">
              {numberformat["2.3"]}&nbsp;
              {commonENLabels.ADDRESS_INFORMATION.ADDRESS_LINE_3}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.ADDRESS_INFORMATION.NOTE_2_3}
            </label>
            <div className="input-group bg-color">
              <input
                type="text"
                minLength={1}
                maxLength={100}
                className="form-control text-uppercase"
                name="permenantRoadOrPo"
                defaultValue={permenantAddressState.permenantRoadOrPo}
                ref={register({ required: false, pattern: addressValidation })}
                onChange={handlePermenantAddressChange}
                autoComplete="off"
              ></input>
            </div>
            {_.get("permenantRoadOrPo.type", errors) === "pattern" && (
              <p className="errorText">
                {" "}
                {profileadressinformation.ENTER_VALID_ADDRESS}
              </p>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="LeftText f11 font-weight">
              {numberformat["2.4"]}&nbsp;
              {commonENLabels.ADDRESS_INFORMATION.STATE_UNION_TERRITORY}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.ADDRESS_INFORMATION.STATE_UNION_TERRITORY}
            </label>
            <span className="errorText">*</span>
            <div className="input-group">
              <select
                className="form-select bg-color"
                name="permenantState"
                value={permenantAddressState.permenantState}
                ref={register({ required: true })}
                onInput={handlePermenantAddressChange}
              >
                <option key={0} value="">
                  {advertisementDetailsLabel.SELECT}
                </option>
                {statesList.length > 0 &&
                  statesList
                    .sort((a, b) => (a.name < b.name ? -1 : 1))
                    .map((ele, i) => (
                      <option key={i} value={ele.code}>
                        {ele.name}
                      </option>
                    ))}
              </select>
            </div>
            {_.get("permenantState.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
            <span className="float-start ms-1 mt-1 f13">
              {" "}
              {profile["INFO_HELP_ERROR_TEXT "]}
            </span>
          </div>
          <div className="col-md-8">
            {permenantAddressState &&
              parseInt(permenantAddressState.permenantState) ===
              commonENLabels.DATABASE_VALUES.STATE_CODE ? (
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.5"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.DISTRICT}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.DISTRICT}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group">
                    <select
                      className="form-select bg-color"
                      name="permenantDistrict"
                      value={permenantAddressState.permenantDistrict}
                      ref={register({ required: true })}
                      onInput={handlePermenantAddressChange}
                      disabled={permenantAddressState.permenantState === ""}
                    >
                      <option key={0} value="">
                        {advertisementDetailsLabel.SELECT}
                      </option>
                      {districtList.length > 0 &&
                        districtList
                          .sort((a, b) => (a.name < b.name ? -1 : 1))
                          .map((ele, i) => (
                            <option key={i} value={ele.code}>
                              {ele.name}
                            </option>
                          ))}
                    </select>
                  </div>
                  {_.get("permenantDistrict.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div>
                {/* permanent Pincode */}
                <div className="col-md-6 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.6"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.PINCODE}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.PINCODE}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      maxLength={6}
                      className="form-control text-uppercase"
                      name="permenantPin"
                      defaultValue={permenantAddressState.permenantPin}
                      ref={register({ required: true, pattern: pincode })}
                      onChange={handlePermenantAddressChange}
                      autoComplete="off"
                    ></input>
                  </div>
                  {_.get("permenantPin.type", errors) === "pattern" && (
                    <p className="errorText">
                      {profileadressinformation.ENTER_VALID_PINCODE}{" "}
                    </p>
                  )}
                  {_.get("permenantPin.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div>
                {/* <div className="col-md-4 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.6"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.TEHSIL}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.TEHSIL}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <select
                      className="form-select bg-color"
                      name="permenantTaluka"
                      value={permenantAddressState.permenantTaluka}
                      ref={register({ required: true })}
                      onInput={handlePermenantAddressChange}
                      disabled={permenantAddressState.permenantDistrict === ""}
                    >
                      <option key={0} value="">
                        {advertisementDetailsLabel.SELECT}
                      </option>
                      {talukaList.length > 0 &&
                        talukaList
                          .sort((a, b) => (a.name < b.name ? -1 : 1))
                          .map((ele, i) => (
                            <option key={i} value={ele.code}>
                              {ele.name}
                            </option>
                          ))}
                    </select>
                  </div>
                  {_.get("permenantTaluka.type", errors) === "required" && (
                      <p className="errorText">
                        {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div> */}
                {/* <div className="col-md-4 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.7"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.VILLAGE_CITY}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.VILLAGE_CITY}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <select
                      className="form-select bg-color"
                      name="permenantVillageCity"
                      value={permenantAddressState.permenantVillageCity}
                      // ref={register({ required: true })}
                      onInput={handlePermenantAddressChange}
                      disabled={permenantAddressState.permenantTaluka === ""}
                    >
                      <option key={0} value="">
                        {advertisementDetailsLabel.SELECT}
                      </option>
                      {villageList.length > 0 &&
                        villageList
                          .sort((a, b) => (a.name < b.name ? -1 : 1))
                          .map((ele, i) => (
                            <option key={i} value={ele.code}>
                              {ele.name}
                            </option>
                          ))}
                    </select>
                  </div>
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                  {_.get("permenantVillageCity.type", errors) ===
                    "required" && (
                      <p className="errorText">
                        {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                </div> */}
              </div>
            ) : (
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.5"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.DISTRICT}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.DISTRICT}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      name="permenantDistrict1"
                      ref={register({
                        required: true,
                        pattern: onlyCharacters,
                      })}
                      defaultValue={permenantAddressState.permenantDistrict1}
                      maxLength={100}
                      onChange={handlePermenantAddressChange}
                      autoComplete="off"
                    />
                  </div>
                  {_.get("permenantDistrict1.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  {_.get("permenantDistrict1.type", errors) === "pattern" && (
                    <p className="errorText">
                      {profileadressinformation.ENTER_VALID_DISTRICT}
                    </p>
                  )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div>
                {/* Permanent Pincode */}
                <div className="col-md-4 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.6"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.PINCODE}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.PINCODE}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      maxLength={6}
                      className="form-control text-uppercase"
                      name="permenantPin"
                      defaultValue={permenantAddressState.permenantPin}
                      ref={register({ required: true, pattern: pincode })}
                      onChange={handlePermenantAddressChange}
                      autoComplete="off"
                    ></input>
                  </div>
                  {_.get("permenantPin.type", errors) === "pattern" && (
                    <p className="errorText">
                      {profileadressinformation.ENTER_VALID_PINCODE}{" "}
                    </p>
                  )}
                  {_.get("permenantPin.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div>

                {/* <div className="col-md-4 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.6"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.TEHSIL}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.TEHSIL}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      name="permenantTaluka1"
                      ref={register({
                        required: false,
                        pattern: onlyCharacters,
                      })}
                      defaultValue={permenantAddressState.permenantTaluka1}
                      maxLength={100}
                      onChange={handlePermenantAddressChange}
                      autoComplete="off"
                    />
                  </div>
                  {_.get("permenantTaluka1.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  {_.get("permenantTaluka1.type", errors) === "pattern" && (
                    <p className="errorText">
                      {profileadressinformation.ENTER_VALID_TEHSIL}
                    </p>
                  )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div> */}
                {/* <div className="col-md-4 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.7"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.VILLAGE_CITY}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.VILLAGE_CITY}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      name="permenantVillageCity1"
                      ref={register({
                        required: false,
                        pattern: onlyCharacters,
                      })}
                      defaultValue={permenantAddressState.permenantVillageCity1}
                      maxLength={100}
                      onChange={handlePermenantAddressChange}
                      autoComplete="off"
                    />
                  </div>
                  {_.get("permenantVillageCity1.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  {_.get("permenantVillageCity1.type", errors) ===
                    "pattern" && (
                      <p className="errorText">
                        {profileadressinformation.ENTER_VALID_VILLAGE_CITY}
                      </p>
                    )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div> */}


              </div>
            )}
          </div>
        </div>
        {/* Permanent Pincode */}
        {/* <div className="col-md-4 mb-3">
          <label className="LeftText f11 font-weight">
            {numberformat["2.6"]}&nbsp;
            {commonENLabels.ADDRESS_INFORMATION.PINCODE}
          </label>
          <label className="f11 margin-top-10">
            {commonHILabels.ADDRESS_INFORMATION.PINCODE}
          </label>
          <span className="errorText">*</span>
          <div className="input-group bg-color">
            <input
              type="text"
              maxLength={6}
              className="form-control text-uppercase"
              name="permenantPin"
              defaultValue={permenantAddressState.permenantPin}
              ref={register({ required: true, pattern: pincode })}
              onChange={handlePermenantAddressChange}
              autoComplete="off"
            ></input>
          </div>
          {_.get("permenantPin.type", errors) === "pattern" && (
            <p className="errorText">
              {profileadressinformation.ENTER_VALID_PINCODE}{" "}
            </p>
          )}
          {_.get("permenantPin.type", errors) === "required" && (
            <p className="errorText">
              {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
            </p>
          )}
          <span className="float-start ms-1 mt-1 f13">
            {" "}
            {profile["INFO_HELP_ERROR_TEXT "]}
          </span>
        </div> */}
        <div className="row bottom-dotted-line ms-1">
          <div className="col-md-6 mb-6 ps-0">
            <h5 className="m-1">
              {profileadressinformation.CORRESPONDANCE_ADDRESS} :{" "}
              {commonHILabels.ADDRESS_INFORMATION.CORRESPONDANCE_ADDRESS}
            </h5>
          </div>
          <div className="col-md-6 mb-6 f15">
            <div className="form-check mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="customCheck"
                name="isSameAsAbove"
                value={isSameAsAbove}
                ref={register({ required: false })}
                checked={isSameAsAbove}
                onClick={() => handleClick()}
              />
              <label className="form-check-label" htmlFor="customCheck">
                {profileadressinformation.SAME_AS_ABOVE}
              </label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="LeftText f11 font-weight">
              {numberformat["2.1"]}&nbsp;
              {commonENLabels.ADDRESS_INFORMATION.ADDRESS_LINE_1}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.ADDRESS_INFORMATION.NOTE_2_1}
            </label>
            <span className="errorText">*</span>
            <div className="input-group bg-color">
              <input
                type="text"
                minLength={1}
                maxLength={100}
                className="form-control text-uppercase"
                name="correspondenceHouseNo"
                defaultValue={correspondenceAddressState.correspondenceHouseNo}
                ref={register({ required: true, pattern: addressValidation })}
                onChange={handleCorrespondenceAddressChange}
                disabled={isSameAsAbove}
                autoComplete="off"
              ></input>
            </div>
            {_.get("correspondenceHouseNo.type", errors) === "pattern" && (
              <p className="errorText">
                {profileadressinformation.ENTER_VALID_ADDRESS}
              </p>
            )}
            {_.get("correspondenceHouseNo.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
            <span className="float-start ms-1 mt-1 f13">
              {" "}
              {profile["INFO_HELP_ERROR_TEXT "]}
            </span>
          </div>
          <div className="col-md-4 mb-3">
            <label className="LeftText f11 font-weight">
              {numberformat["2.2"]}&nbsp;
              {commonENLabels.ADDRESS_INFORMATION.ADDRESS_LINE_2}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.ADDRESS_INFORMATION.NOTE_2_2}
            </label>
            <div className="input-group bg-color">
              <input
                type="text"
                minLength={1}
                maxLength={100}
                className="form-control text-uppercase"
                name="correspondenceBuildingName"
                defaultValue={
                  correspondenceAddressState.correspondenceBuildingName
                }
                ref={register({ required: false, pattern: addressValidation })}
                onChange={handleCorrespondenceAddressChange}
                disabled={isSameAsAbove}
                autoComplete="off"
              ></input>
            </div>
            {_.get("correspondenceBuildingName.type", errors) === "pattern" && (
              <p className="errorText">
                {" "}
                {profileadressinformation.ENTER_VALID_ADDRESS}
              </p>
            )}
          </div>
          <div className="col-md-4 mb-3">
            <label className="LeftText f11 font-weight">
              {numberformat["2.3"]}&nbsp;
              {commonENLabels.ADDRESS_INFORMATION.ADDRESS_LINE_3}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.ADDRESS_INFORMATION.NOTE_2_3}
            </label>
            <div className="input-group bg-color">
              <input
                type="text"
                minLength={1}
                maxLength={100}
                className="form-control text-uppercase"
                name="correspondenceRoadOrPo"
                defaultValue={correspondenceAddressState.correspondenceRoadOrPo}
                ref={register({ required: false, pattern: addressValidation })}
                onChange={handleCorrespondenceAddressChange}
                disabled={isSameAsAbove}
                autoComplete="off"
              ></input>
            </div>
            {_.get("correspondenceRoadOrPo.type", errors) === "pattern" && (
              <p className="errorText">
                {" "}
                {profileadressinformation.ENTER_VALID_ADDRESS}
              </p>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="LeftText f11 font-weight">
              {numberformat["2.4"]}&nbsp;
              {commonENLabels.ADDRESS_INFORMATION.STATE_UNION_TERRITORY}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.ADDRESS_INFORMATION.STATE_UNION_TERRITORY}
            </label>
            <span className="errorText">*</span>
            <div className="input-group">
              <select
                className="form-select bg-color"
                name="correspondenceState"
                value={correspondenceAddressState.correspondenceState}
                ref={register({ required: true })}
                onInput={(e) => {
                  handleCorrespondenceAddressChange(e);
                }}
                disabled={isSameAsAbove}
              >
                <option value="">{advertisementDetailsLabel.SELECT}</option>
                {statesList.length > 0 &&
                  statesList
                    .sort((a, b) => (a.name < b.name ? -1 : 1))
                    .map((ele, i) => (
                      <option key={i} value={ele.code}>
                        {ele.name}
                      </option>
                    ))}
              </select>
            </div>
            {_.get("correspondenceState.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
            <span className="float-start ms-1 mt-1 f13">
              {" "}
              {profile["INFO_HELP_ERROR_TEXT "]}
            </span>
          </div>
          <div className="col-md-8">
            {correspondenceAddressState &&
              parseInt(correspondenceAddressState.correspondenceState) ===
              commonENLabels.DATABASE_VALUES.STATE_CODE ? (
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.5"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.DISTRICT}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.DISTRICT}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group">
                    <select
                      className="form-select bg-color"
                      name="correspondenceDistrict"
                      value={correspondenceAddressState.correspondenceDistrict}
                      ref={register({ required: true })}
                      onInput={handleCorrespondenceAddressChange}
                      disabled={
                        isSameAsAbove ||
                        correspondenceAddressState.correspondenceState === ""
                      }
                    >
                      <option value="">
                        {advertisementDetailsLabel.SELECT}
                      </option>
                      {districtCorrespondenceList.length > 0 &&
                        districtCorrespondenceList
                          .sort((a, b) => (a.name < b.name ? -1 : 1))
                          .map((ele, i) => (
                            <option key={i} value={ele.code}>
                              {ele.name}
                            </option>
                          ))}
                    </select>
                  </div>
                  {_.get("correspondenceDistrict.type", errors) ===
                    "required" && (
                      <p className="errorText">
                        {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.6"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.PINCODE}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.PINCODE}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      maxLength={6}
                      className="form-control text-uppercase"
                      name="correspondencePin"
                      defaultValue={correspondenceAddressState.correspondencePin}
                      ref={register({ required: true, pattern: pincode })}
                      onChange={handleCorrespondenceAddressChange}
                      disabled={isSameAsAbove}
                      autoComplete="off"
                    ></input>
                  </div>
                  {_.get("correspondencePin.type", errors) === "pattern" && (
                    <p className="errorText">
                      {profileadressinformation.ENTER_VALID_PINCODE}
                    </p>
                  )}
                  {_.get("correspondencePin.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div>

                {/* <div className="col-md-4 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.6"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.TEHSIL}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.TEHSIL}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <select
                      className="form-select bg-color"
                      name="correspondenceTaluka"
                      value={correspondenceAddressState.correspondenceTaluka}
                      ref={register({ required: false })}
                      onInput={handleCorrespondenceAddressChange}
                      disabled={
                        isSameAsAbove ||
                        correspondenceAddressState.correspondenceDistrict === ""
                      }
                    >
                      <option value="">
                        {advertisementDetailsLabel.SELECT}
                      </option>
                      {talukaCorrespondenceList.length > 0 &&
                        talukaCorrespondenceList
                          .sort((a, b) => (a.name < b.name ? -1 : 1))
                          .map((ele, i) => (
                            <option key={i} value={ele.code}>
                              {ele.name}
                            </option>
                          ))}
                    </select>
                  </div>
                  {_.get("correspondenceTaluka.type", errors) ===
                    "required" && (
                      <p className="errorText">
                        {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div> */}
                {/* <div className="col-md-4 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.7"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.VILLAGE_CITY}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.VILLAGE_CITY}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <select
                      className="form-select bg-color"
                      name="correspondenceVillageCity"
                      value={
                        correspondenceAddressState.correspondenceVillageCity
                      }
                      ref={register({ required: false })}
                      onInput={handleCorrespondenceAddressChange}
                      disabled={
                        isSameAsAbove ||
                        correspondenceAddressState.correspondenceTaluka === ""
                      }
                    >
                      <option value="">
                        {advertisementDetailsLabel.SELECT}
                      </option>
                      {villageCorrospondenceList.length > 0 &&
                        villageCorrospondenceList
                          .sort((a, b) => (a.name < b.name ? -1 : 1))
                          .map((ele, i) => (
                            <option key={i} value={ele.code}>
                              {ele.name}
                            </option>
                          ))}
                    </select>
                  </div>
                  {_.get("correspondenceVillageCity.type", errors) ===
                    "required" && (
                      <p className="errorText">
                        {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                      </p>
                    )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div> */}
              </div>
            ) : (
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.5"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.DISTRICT}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.DISTRICT}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      name="correspondenceDistrict1"
                      defaultValue={
                        correspondenceAddressState.correspondenceDistrict1
                      }
                      maxLength={100}
                      ref={register({
                        required: true,
                        pattern: onlyCharacters,
                      })}
                      disabled={isSameAsAbove}
                      onChange={handleCorrespondenceAddressChange}
                      autoComplete="off"
                    />
                  </div>
                  {_.get("correspondenceDistrict1.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  {_.get("correspondenceDistrict1.type", errors) ===
                    "pattern" && (
                      <p className="errorText">
                        {profileadressinformation.ENTER_VALID_DISTRICT}
                      </p>
                    )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.6"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.PINCODE}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.PINCODE}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      maxLength={6}
                      className="form-control text-uppercase"
                      name="correspondencePin"
                      defaultValue={correspondenceAddressState.correspondencePin}
                      ref={register({ required: true, pattern: pincode })}
                      onChange={handleCorrespondenceAddressChange}
                      disabled={isSameAsAbove}
                      autoComplete="off"
                    ></input>
                  </div>
                  {_.get("correspondencePin.type", errors) === "pattern" && (
                    <p className="errorText">
                      {profileadressinformation.ENTER_VALID_PINCODE}
                    </p>
                  )}
                  {_.get("correspondencePin.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div>

                {/* <div className="col-md-4 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.6"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.TEHSIL}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.TEHSIL}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      name="correspondenceTaluka1"
                      maxLength={100}
                      defaultValue={
                        correspondenceAddressState.correspondenceTaluka1
                      }
                      ref={register({
                        required: false,
                        pattern: onlyCharacters,
                      })}
                      disabled={isSameAsAbove}
                      onChange={handleCorrespondenceAddressChange}
                      autoComplete="off"
                    />
                  </div>
                  {_.get("correspondenceTaluka1.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  {_.get("correspondenceTaluka1.type", errors) ===
                    "pattern" && (
                      <p className="errorText">
                        {profileadressinformation.ENTER_VALID_TEHSIL}
                      </p>
                    )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div> */}
                {/* <div className="col-md-4 mb-3">
                  <label className="LeftText f11 font-weight">
                    {numberformat["2.7"]}&nbsp;
                    {commonENLabels.ADDRESS_INFORMATION.VILLAGE_CITY}
                  </label>
                  <label className="f11 margin-top-10">
                    {commonHILabels.ADDRESS_INFORMATION.VILLAGE_CITY}
                  </label>
                  <span className="errorText">*</span>
                  <div className="input-group bg-color">
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      name="correspondenceVillageCity1"
                      maxLength={100}
                      defaultValue={
                        correspondenceAddressState.correspondenceVillageCity1
                      }
                      ref={register({
                        required: false,
                        pattern: onlyCharacters,
                      })}
                      disabled={isSameAsAbove}
                      onChange={handleCorrespondenceAddressChange}
                      autoComplete="off"
                    />
                  </div>
                  {_.get("correspondenceVillageCity1.type", errors) === "required" && (
                    <p className="errorText">
                      {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                    </p>
                  )}
                  {_.get("correspondenceVillageCity1.type", errors) ===
                    "pattern" && (
                      <p className="errorText">
                        {profileadressinformation.ENTER_VALID_VILLAGE_CITY}
                      </p>
                    )}
                  <span className="float-start ms-1 mt-1 f13">
                    {" "}
                    {profile["INFO_HELP_ERROR_TEXT "]}
                  </span>
                </div> */}
              </div>
            )}
          </div>
        </div>
        {/* <div className="col-md-2 mb-3">
          <label className="LeftText f11 font-weight">
            {numberformat["2.6"]}&nbsp;
            {commonENLabels.ADDRESS_INFORMATION.PINCODE}
          </label>
          <label className="f11 margin-top-10">
            {commonHILabels.ADDRESS_INFORMATION.PINCODE}
          </label>
          <span className="errorText">*</span>
          <div className="input-group bg-color">
            <input
              type="text"
              maxLength={6}
              className="form-control text-uppercase"
              name="correspondencePin"
              defaultValue={correspondenceAddressState.correspondencePin}
              ref={register({ required: true, pattern: pincode })}
              onChange={handleCorrespondenceAddressChange}
              disabled={isSameAsAbove}
              autoComplete="off"
            ></input>
          </div>
          {_.get("correspondencePin.type", errors) === "pattern" && (
            <p className="errorText">
              {profileadressinformation.ENTER_VALID_PINCODE}
            </p>
          )}
          {_.get("correspondencePin.type", errors) === "required" && (
            <p className="errorText">
              {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
            </p>
          )}
          <span className="float-start ms-1 mt-1 f13">
            {" "}
            {profile["INFO_HELP_ERROR_TEXT "]}
          </span>
        </div> */}
        <p className="paraCss"></p>

        <div className="text-center">
          <hr></hr>

          {
          props.profileStatus !== true ? (
              <button
                type="submit"
                className=" btn btn-primary custom_button  m-1  "
                disabled={isDisableAllTabSave}
              >
                {" "}
           {profile.SAVE}
              </button>
            ) : (
              <div className="text-center">
                {(() => {
                  const AddressInfoList = props.enableEditProfileWithLock?.AddressInfo?.split(",") || [];
                  const canUpdate = AddressInfoList.includes("U");
                   const canCreate = AddressInfoList.includes("C");
                   const isReadOnly = AddressInfoList.includes("R");

                  if (props.enableEditProfileWithLock?.editProfileWithLock == "1") {
                    if (canUpdate || canCreate) {
                      return (
                        <button
                          type="submit"
                          className=" btn btn-primary custom_button  m-1  "
                          disabled={isDisableAllTabSave}
                        >
                          {" "}
                          {profile.SAVE}
                        </button>
                      );
                    } else if (isReadOnly) {
                      return (
                        <span className="profile_disable_button">
                          {commonENLabels.PERSONAL_INFORMATION.DISABLE_BUTTON_TEXT}
                        </span>
                      );
                    }
                  }
                  return null;
                })()}
              </div>
            )
          }


          {/* {
            addressInformationResponse?.permenantAddressState?.isLocked !== true  ? (
              <button
                type="submit"
                className=" btn btn-primary custom_button  m-1  "
                disabled={isDisableAllTabSave}
              >
                {" "}
                {profile.SAVE}
              </button>
            ) : (
              <span className="profile_disable_button">
                {commonENLabels.PERSONAL_INFORMATION.DISABLE_BUTTON_TEXT}
              </span>
            )} */}
        </div>
      </div>
    </form >
  );
}

export default AddressInformation;
